import React from 'react';
import PropTypes from 'prop-types';

import DoctorProfile from './DoctorProfile/index';
import DoctorAppointment from './DoctorAppointment/index';
import styles from './doctorContainer.module.css';
import {
  DoctorProfilePropType,
  SelectedTimePropType,
} from '../propTypes/index';

const DoctorContainer = ({
  doctor,
  selectedTime,
  setTime,
  onClick,
  goToDate,
  currentFilter,
  filterAfternoon,
  filterEvening,
  filterMorning,
  morning, afternoon, evening
}) => (
  <div className={styles.container}>
    <DoctorProfile doctor={doctor} onClick={onClick} />
    <DoctorAppointment
      selectedTime={selectedTime}
      setTime={setTime}
      appointmentSlots={doctor.AvailableSlots}
      doctorId={doctor.PmsUserId}
      nextAvailableSlot={doctor.NextAvailableSlot}
      goToDate={goToDate}
      currentFilter={currentFilter}
      filterMorning={filterMorning}
      filterAfternoon={filterAfternoon}
      filterEvening={filterEvening}
      morning={morning}
      afternoon={afternoon}
      evening={evening}
      sessionId={doctor.SessionId}
    />
  </div>
);

DoctorContainer.propTypes = {
  doctor: DoctorProfilePropType.isRequired,
  selectedTime: SelectedTimePropType.isRequired,
  setTime: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  goToDate: PropTypes.func.isRequired,
};

export default DoctorContainer;
